class ItemTabelasController extends AbstractController
  @$injector = [ '$scope', 'pathService', 'itemTabelasService' ]

  constructor: ($injector, $scope, pathService, @itemTabelasService)->
    super($injector)


    @titles =
      isencao: 'Isenção'
      reducao_base_calculo: 'Reduçao base de calculo'
      substituicao_tributaria: 'Substituição tributária'

    @tabController = $scope.tabController
    @loadingTracker = @promiseTracker()
    @url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/icms/item-tabelas/'
    @modalItem = @openPopup("#{@url}modal/modal.html", 'itemTabelasModalController as ctrl', 'md', 'static')
    @modalImportar = @openPopup("#{@url}importar.html", 'itemTabelasImportarController as ctrl')

    @listOfItem = []

    @filtro =
      page: 1
      tipoTabela: $scope.tabData.tipoTabela

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @buscarItens()

  buscarItens: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @itemTabelasService.getList(filtro, (result) =>
      if result.success
        @listOfItem = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar essa lista.', 'Erro!', false)
    )

  add: (item) ->
    item.tipoTabela = item.tipo if item
    item = { tipoTabela: angular.copy @filtro.tipoTabela } if !item
    @modalItem({
      item: => item
    }, (result) =>
      @buscarItens())

  edit: (item) ->
    item.tipoTabela = angular.copy @filtro.tipoTabela
    @modalItem({
      item: => angular.copy item
    }, (result) =>
      @buscarItens())

  remover: (itemTabela)->
    Confirm.warning('Atenção', "Deseja realmente remover o item <strong>#{itemTabela.descricao}</strong> NCM: <strong>#{itemTabela.ncm}</strong>?", {
      Sim: =>
        @itemTabelasService.delete(itemTabela.id, (result)=>
          if(result.success)
            Alert.success("O item <strong>#{itemTabela.descricao}</strong> NCM: <strong>#{itemTabela.ncm}</strong> foi removido.", 'Sucesso')
            @buscarItens()
          else
            Alert.error("Ocorreu um erro ao remover o item: <strong>#{itemTabela.descricao}</strong> NCM: <strong>#{itemTabela.ncm}</strong>.")
        )
      Não: ''
    })

  removerExcecoesConfirmadas: (itemTabela) ->
    Confirm.warning('Atenção', "Deseja realmente remover todas as confirmações de exceção para o item
                                <strong>#{itemTabela.descricao}</strong> NCM: <strong>#{itemTabela.ncm}</strong>?", {
      Sim: =>
        @itemTabelasService.removerExcecaoConfirmada(itemTabela.id, (result)=>
          if(result.success)
            Alert.success("#{result.data.removidos} confirmações de exceção para o item <strong>#{itemTabela.descricao}
                           </strong> NCM: <strong>#{itemTabela.ncm}</strong> foram removidas.",
              'Sucesso')
          else
            Alert.error("Ocorreu um erro ao remover as confirmações de exceção para o item:
                         <strong>#{itemTabela.descricao}</strong> NCM: <strong>#{itemTabela.ncm}</strong>.")
        )
      Não: ''
    })

  clonar: (item) ->
    copia = angular.copy item
    copia.id = null
    copia.excecoes = copia.excecoes?.map((excecao) =>
      excecao.id = null
      excecao.excecao = excecao.tipo
      excecao.tipo = null
      excecao.regraValidacao = excecao.regraValidacao?.id
      return excecao
    )
    @add(copia)

  abrirItem: (item)->
    @tabController.addTab({
      id: "item-tabelas-excecao-#{item.id}"
      label: "Exceções para o item ##{item.id} - #{@titles[@filtro.tipoTabela]}"
      closable: true
      active: true
      url: @url + "excecoes/index.html",
      data: {
        item: item
      }
    })

  baixar: () ->
    cbk.download '/api/eficiencia-fiscal/item-tabela.csv?tipoTabela=' + @filtro.tipoTabela

  importar: ->
    @modalImportar({
      tipo: =>
        tipo: angular.copy @filtro.tipoTabela
        nome: @titles[@filtro.tipoTabela]
    }, (result) =>)

angular.module("eficienciaFiscalModule").controller('itemTabelasController', ItemTabelasController)

class ItemTabelasModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'itemTabelasService', 'aplicacaoService', 'estadoService','convenioIcmsService', 'eflService', 'regraValidacaoService', 'item' ]

  constructor: ($injector, @modalInstance, @itemTabelasService, @aplicacaoService, @estadoService, @convenioIcmsService, @eflService, @regraValidacaoService, @item)->
    super($injector)

    @item.aplicacoes = [] if @item.aplicacoes == undefined
    @item.observacoes = [] if @item.observacoes == undefined

    @observacao = ''
    @aplicacao = ''

    @listOfConvenio = []
    @listOfRegraValidacao = []
    titles =
      isencao: 'Isenção'
      reducao_base_calculo: 'Reduçao base de cálculo'
      substituicao_tributaria: 'Substituição tributária'

    @estadoService.getList (data) => @listOfEstado = data
    @aplicacaoService.getList (data) => @listOfAplicacao = data
    @convenioIcmsService.getList({},(result) =>
        @listOfConvenio = result.data.items.uniqBy((c) => c.convenio) if result.success
    )
    @regraValidacaoService.getList({},(result) =>
        @listOfRegraValidacao = result.data.items if result.success
    )

    @submitTracker = @promiseTracker()
    @modalTitle = titles[@item.tipoTabela]

  addObservacao: ->
    @item.observacoes.push {texto: @observacao}
    @observacao = ''

  addAplicacao: ->
    @item.aplicacoes.push @aplicacao
    @aplicacao = {}

  removerObservacao: (index)->
    if(index > -1)
      @item.observacoes.splice(index, 1)

  removerAplicacao: (index)->
    if(index > -1)
      @item.aplicacoes.splice(index, 1)

  testarRegra: (texto = "") ->
    @eflService.test(regra: @item.regraExpressao, itens: texto.split("\n"), (result) =>
      @regraValidacaoTestResult = result
    )

  salvar: (form) ->
    if form.$valid
      item = angular.copy @item
      item.regraValidacao = item.regraValidacao.id if item.regraValidacao
      @submitTracker.addPromise @itemTabelasService.save(item, (result) =>
        if result.success
          Alert.success("Item Nº  <strong>#{result.data.id}</strong> #{if item.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
          @modalInstance.close(new Retorno(true, null, result.data))
        else
          switch result.message
            when 'regra_invalida'
              Alert.warning("""
Não foi possível <strong>#{if item.id then 'atualizar' else 'criar'}</strong> o item, pois sua regra de validação está <strong>inválida</strong>. <br/>
Por favor, teste a regra na aba "Regra de validação" para identificar o erro e tente novamente.
""", 'Sucesso!')
            else
              Alert.warning("Não foi possível <strong>#{if item.id then 'atualizar' else 'criar'}</strong> o item.")

      )

angular.module("eficienciaFiscalModule").controller('itemTabelasModalController', ItemTabelasModalController)

class ItemTabelasImportarController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'FileUploader', 'tipo' ]

  constructor: ($injector, @modalInstance, FileUploader, @tipo) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @url = "/api/eficiencia-fiscal/item-tabela"

    @uploader = new FileUploader(
      url: @url
      headers: cbk.getHeaders()
      filters: [ {
        name: 'extFilter'
        fn: (item, options) =>
          extension = item.type == 'text/csv' || item.type == "application/vnd.ms-excel"
          @extension = !extension
          @uploader.clearQueue() unless extension
          document.getElementById('file').value = '' unless extension

          return extension
      } ]
      onBeforeUploadItem: (item) =>
        item.formData = [ {
          tipoTabela: @tipo.tipo
        } ]
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      if response.success
        @Alert.success("O CSV de itens #{@tipo.nome} específicas foi importado com sucesso.", 'Sucesso')
        @modalInstance.close(new Retorno(response.success, null, response.data))
      else
        if response.message == 'ncm_em_branco'
          @Alert.warning('Arquivo importado possui NCM em branco. Verifique e tente novamente.', 'Operação não realizada', false)
        else
          @Alert.warning('Ocorreu um erro ao realizar a importação.', 'Operação não realizada', false)

  importar: () ->
    @uploader.uploadAll()

  baixar: () ->
    cbk.download(@url + '.csv?tipoTabela=' + @tipo.tipo)

angular.module('eficienciaFiscalModule').controller('itemTabelasImportarController', ItemTabelasImportarController)
